import { useQuery } from '@apollo/client'

export { useQuery }
